import React, { useMemo } from 'react'
import { useRequestAssigneeGroups } from 'src/components/async/DocumentRequest/useRequestAssigneeGroups'
import { REQUEST_ASSIGNEE_GROUP_PREFIX } from 'src/pages/Requests/requests.constants'
import { FilterName } from '../FilterBar.types'
import { OwnerFilterDropdown } from './OwnerFilterDropdown'

// The owner filter plus the account's user groups: a request is assigned to
// either.
export const RequestAssigneeFilterDropdown = ({
  customName,
  isNested = false,
}: {
  customName?: string
  isNested?: boolean
}): JSX.Element => {
  const { data } = useRequestAssigneeGroups()
  const groups = useMemo(
    () =>
      data?.getItemsList().map((group) => ({
        value: `${REQUEST_ASSIGNEE_GROUP_PREFIX}${group.getId()}`,
        label: group.getName(),
      })) ?? [],
    [data],
  )
  return (
    <OwnerFilterDropdown
      customName={customName}
      isNested={isNested}
      filterName={FilterName.ASSIGNEE}
      groups={groups}
    />
  )
}
